import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-item-status',
    templateUrl: './item-status.component.html',
    styleUrls: ['./item-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ItemStatusComponent {

    @Input() status: boolean;
}
